/**
 * Validates a value is a valid url.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name url
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  try {
    new URL(value);
    return Promise.resolve(null);
  } catch (e) {
    return Promise.resolve('not-a-url');
  }
}

module.exports = validate;